import React from "react";

import Tag from "antd/es/tag";

import HasSourceObject from "@mapmycustomers/shared/types/base/HasSourceObject";

import { RegistryProps } from "@app/component/FieldGrid/utils/ComponentRegistry";
import useSourceObjectLabel from "@app/util/hook/useSourceObjectLabel";

const SourceObjectField = ({ entity, field }: RegistryProps) => {
  const label = useSourceObjectLabel(
    entity.entity,
    field.getValueFor(entity) as HasSourceObject["sourceObject"] | undefined
  );

  return label ? <Tag>{label}</Tag> : null;
};

export default SourceObjectField;
